export default {"src":"/_next/static/media/swvl-logo.479662f8.svg","height":40,"width":64};